"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoreFormulaSettings = exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.object.assign");

var _Panel = _interopRequireDefault(require("../panel/Panel"));

var _utils = _interopRequireDefault(require("../base/editForm/utils"));

var _ExpertiseComponent = _interopRequireDefault(require("./ExpertiseComponent"));

var _lodash = _interopRequireDefault(require("lodash"));

var _NumberUtils = _interopRequireDefault(require("../../utils/NumberUtils"));

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NestedExpertiseComponent =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(NestedExpertiseComponent, _WithLogic);

  function NestedExpertiseComponent() {
    _classCallCheck(this, NestedExpertiseComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(NestedExpertiseComponent).apply(this, arguments));
  }

  _createClass(NestedExpertiseComponent, [{
    key: "build",
    value: function build(state) {
      _get(_getPrototypeOf(NestedExpertiseComponent.prototype), "build", this).call(this, state);

      this.element.classList.add('formio-component', "formio-component-".concat(this.component.type));
    }
  }, {
    key: "expertiseLabelInfo",
    value: function expertiseLabelInfo() {
      var infoElem = this.ce('span', {
        class: 'score'
      });
      var scoreTitle = this.ce('span', {
        class: 'score-title'
      });
      scoreTitle.innerText = this.t('score');
      this.scoreElem = this.ce('span', {
        class: 'score-value'
      });
      infoElem.appendChild(scoreTitle);
      infoElem.appendChild(this.scoreElem);
      this.displayScore();
      return infoElem;
    }
  }, {
    key: "addComponent",
    value: function addComponent(component, element, data, before, noAdd, state) {
      var _this = this;

      var comp = _get(_getPrototypeOf(NestedExpertiseComponent.prototype), "addComponent", this).call(this, component, element, data, before, noAdd, state);

      comp.on('componentChange', function () {
        setTimeout(function () {
          _this.displayScore();
        }, 10);
      });
      var calculationOption = this.getCalculationOption();

      if (typeof comp.setCalculationOption === 'function') {
        comp.setCalculationOption(calculationOption);
      }

      var totalWeight = 0;
      this.withAllVisibleComponents(function (component) {
        if (typeof component.getWeight === 'function') {
          totalWeight = totalWeight + component.getWeight();
        }
      });
      this.withAllVisibleComponents(function (component) {
        if (typeof component.setTotalWeight === 'function') {
          component.setTotalWeight(totalWeight, _this.component.digitsAfterComma);
        }
      });
      this.displayScore();
      return comp;
    }
  }, {
    key: "withComponentsRecursively",
    value: function withComponentsRecursively(components, func) {
      var _this2 = this;

      components.forEach(function (component) {
        if (typeof component.getComponents === 'function') {
          _this2.withComponentsRecursively(component.getComponents(), func);
        } else {
          func(component);
        }
      });
    }
  }, {
    key: "withAllComponents",
    value: function withAllComponents(func) {
      this.withComponentsRecursively(this.getComponents(), func);
    }
  }, {
    key: "withAllVisibleComponents",
    value: function withAllVisibleComponents(func) {
      this.withAllComponents(function (component) {
        if (component.visible) {
          func(component);
        }
      });
    }
  }, {
    key: "getScore",
    value: function getScore() {
      if (this.hasFormula()) {
        return this.evaluateFormula();
      } else {
        return this.getSumScore();
      }
    }
  }, {
    key: "getSumScore",
    value: function getSumScore() {
      var _this3 = this;

      var score = 0;
      this.withAllVisibleComponents(function (component) {
        if (typeof component.getScore === 'function') {
          score = score + component.getScore(_this3.component.digitsAfterComma);
        }
      });
      return score;
    }
  }, {
    key: "getWeightedScore",
    value: function getWeightedScore() {
      if (this.hasFormula()) {
        return this.evaluateFormula();
      } else {
        return this.getWeightedSumScore();
      }
    }
  }, {
    key: "getWeightedSumScore",
    value: function getWeightedSumScore() {
      var score = 0;
      var digitsAfterComma = this.component.digitsAfterComma;
      this.withAllVisibleComponents(function (component) {
        if (typeof component.getWeightedScore === 'function') {
          score = score + component.getWeightedScore(digitsAfterComma);
        }
      });
      return _NumberUtils.default.round(score * this.getWeight(), digitsAfterComma);
    }
  }, {
    key: "getWeightedPartScore",
    value: function getWeightedPartScore() {
      if (this.hasFormula()) {
        return this.evaluateFormula();
      } else {
        return this.getWeightedPartSumScore();
      }
    }
  }, {
    key: "getWeightedPartSumScore",
    value: function getWeightedPartSumScore() {
      var score = 0;
      var digitsAfterComma = this.component.digitsAfterComma;
      this.withAllVisibleComponents(function (component) {
        if (typeof component.getWeightedPartScore === 'function') {
          score = score + component.getWeightedPartScore(digitsAfterComma);
        }
      });
      return _NumberUtils.default.round(score * this.getWeightPart(), digitsAfterComma);
    }
  }, {
    key: "hasFormula",
    value: function hasFormula() {
      return this.component.countScoreMethod === 'formula' && !_lodash.default.isEmpty(this.component.formula);
    }
  }, {
    key: "evalContext",
    value: function evalContext(additional) {
      return _get(_getPrototypeOf(NestedExpertiseComponent.prototype), "evalContext", this).call(this, Object.assign({
        expertiseData: this.getBaseExpertiseInfo()
      }, additional));
    }
  }, {
    key: "evaluateFormula",
    value: function evaluateFormula() {
      return this.evaluate(this.component.formula, {}, 'score');
    }
  }, {
    key: "getCalculatedScore",
    value: function getCalculatedScore() {
      if (this.hasFormula()) {
        return this.evaluateFormula();
      } else {
        var calculationOption = this.getCalculationOption()();

        switch (calculationOption) {
          case 'weightedPart':
            return this.getWeightedPartSumScore();

          default:
            return this.getWeightedSumScore();
        }
      }
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.t(this.component.title);
    }
  }, {
    key: "getNonExpertiseComponentInfo",
    value: function getNonExpertiseComponentInfo(component) {
      return {
        key: component.key,
        title: component.t(component.component.label),
        viewValue: component.getView(component.getValue()),
        value: component.dataValue
      };
    }
  }, {
    key: "childExpertiseInfo",
    value: function childExpertiseInfo(component) {
      var that = this;

      if (typeof component.getExpertiseInfo === 'function') {
        return component.getExpertiseInfo();
      } else if (typeof component.getComponents === 'function') {
        var childComponentsExpertiseInfo = {};
        component.getComponents().forEach(function (childComponent) {
          if (component.visible) {
            childComponentsExpertiseInfo[childComponent.key] = that.childExpertiseInfo(childComponent);
          }
        });
        return childComponentsExpertiseInfo;
      } else {
        return that.getNonExpertiseComponentInfo(component);
      }
    }
  }, {
    key: "getBaseExpertiseInfo",
    value: function getBaseExpertiseInfo() {
      var _this4 = this;

      var childComponentsExpertiseInfo = {};
      this.getComponents().forEach(function (component) {
        if (component.visible) {
          childComponentsExpertiseInfo[component.key] = _this4.childExpertiseInfo(component);
        }
      });
      return {
        weight: this.getWeight(),
        weightPart: this.getWeightPart(),
        score: this.getSumScore(),
        weightedScore: this.getWeightedSumScore(),
        weightedPartScore: this.getWeightedPartSumScore(),
        components: childComponentsExpertiseInfo
      };
    }
  }, {
    key: "getExpertiseInfo",
    value: function getExpertiseInfo() {
      var calculationOption = this.getCalculationOption()();
      var calculatedScore = this.getCalculatedScore();
      return Object.assign({
        key: this.key,
        title: this.getTitle(),
        value: calculatedScore,
        viewValue: calculatedScore,
        calculationOption: calculationOption
      }, this.getBaseExpertiseInfo());
    }
  }, {
    key: "isNestedExpertiseComponent",
    get: function get() {
      return true;
    }
  }]);

  return NestedExpertiseComponent;
}((0, _WithLogic2.default)((0, _ExpertiseComponent.default)(_Panel.default)));

exports.default = NestedExpertiseComponent;
var ScoreFormulaSettings = [{
  type: 'select',
  input: true,
  weight: 20,
  key: 'countScoreMethod',
  defaultValue: 'sum',
  label: 'Способ подсчета баллов',
  dataSrc: 'values',
  searchEnabled: false,
  data: {
    values: [{
      label: 'Сумма',
      value: 'sum'
    }, {
      label: 'Формула',
      value: 'formula'
    }]
  }
}, {
  type: 'panel',
  title: 'Формула подсчета баллов',
  collapsible: false,
  collapsed: false,
  style: {
    'margin-bottom': '10px'
  },
  key: 'formula-panel',
  weight: 30,
  conditional: {
    json: {
      '===': [{
        var: 'data.countScoreMethod'
      }, 'formula']
    }
  },
  components: [_utils.default.logicVariablesTable('<tr><th>expertiseData</th><td>{<br />' + '            weight: <вес>,<br />' + '            weightPart: <нормализованный вес>,<br />' + '            score: <баллы без учета веса, подсчитанные суммой>,<br />' + '            weightedScore: <взвешенные баллы, подсчитанные суммой>,<br />' + '            components: <объект с такой же информацией, для всех дочерних компонентов {<код поля>: <информация о поле>}><br />' + '        }</td></tr>'), {
    type: 'textarea',
    key: 'formula',
    rows: 5,
    editor: 'ace',
    hideLabel: true,
    input: true,
    placeholder: 'score = ...;'
  }]
}, {
  type: 'number',
  input: true,
  weight: 40,
  key: 'digitsAfterComma',
  defaultValue: 2,
  label: 'Количество цифр после запятой',
  validate: {
    required: true,
    validate: {
      pattern: '^[0-9]\\d*$'
    }
  }
}];
exports.ScoreFormulaSettings = ScoreFormulaSettings;